import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Posts from './Posts';
import './css/App.css';

class App extends Component {
  render() {
    return (
      <BrowserRouter>   
        <Route path="/:slug?" component={Posts} />
      </BrowserRouter>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js